import { render, staticRenderFns } from "./AminPanelSearch.vue?vue&type=template&id=4511ce3d"
import script from "./AminPanelSearch.vue?vue&type=script&lang=js"
export * from "./AminPanelSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports